import { render } from "./ClickDataForm.vue?vue&type=template&id=774cd4a3&scoped=true"
import script from "./ClickDataForm.vue?vue&type=script&lang=js"
export * from "./ClickDataForm.vue?vue&type=script&lang=js"

import "./ClickDataForm.vue?vue&type=style&index=0&id=774cd4a3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774cd4a3"]])

export default __exports__